<div class="app-menu navbar-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box">
    <!-- Dark Logo-->
    <a class="logo logo-dark" href="index.html">
      <span class="logo-sm">
        <img alt="" height="22" src="assets/images/logo-sm-dark.svg">
      </span>
      <span class="logo-lg">
        <img alt="" height="32" src="/assets/images/logo-light.svg">
      </span>
    </a>
    <!-- Light Logo-->
    <a class="logo logo-light" href="index.html">
      <span class="logo-sm">
        <img alt="" height="22" src="assets/images/logo-sm-light.svg">
      </span>
      <span class="logo-lg">
        <img alt="" height="32" src="assets/images/logo-dark.svg">
      </span>
    </a>
    <button class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover" type="button">
      <i class="ri-record-circle-line"></i>
    </button>
  </div>

  <hr class="mt-0">

  <ngx-simplebar style="height: 100%;">
    <div class="container-fluid">

      <div id="two-column-menu">
      </div>
      <ul class="navbar-nav" id="navbar-nav">
        @for (item of menuItems; track $index) {
          <ng-container>
            @if (item.isTitle) {
              <li class="menu-title"><span>{{ item.label | translate }}</span></li>
            } @else if (!item.isTitle && !item.isLayout) {
              <li class="nav-item">
                @if (hasItems(item)) {
                  <a href="javascript:void(0);" class="nav-link menu-link"
                     [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}" data-bs-toggle="collapse"
                     aria-expanded="false" (click)="toggleItem($event)">
                    <i class="{{ item.icon }}"></i>
                    <span> {{ item.label | translate }}</span>
                    @if (item.badge) {
                      <span class="badge badge-pill bg-danger">
                        {{ item.badge | translate }}
                      </span>
                    }
                  </a>

                  <div class="collapse menu-dropdown mega-dropdown-menu">
                    <ul class="nav nav-sm flex-column" aria-expanded="false">
                      @for (subitem of item.subItems; track $index) {
                        <li class="nav-item">
                          @if (hasItems(subitem)) {
                            <a class="nav-link" href="javascript:void(0);" [attr.data-parent]="subitem.parentId"
                               data-bs-toggle="collapse" aria-expanded="false" (click)="toggleSubItem($event)">
                              <i class="{{ subitem.icon }}"></i>
                              {{ subitem.label | translate }}
                              @if (subitem.badge) {
                                <span class="badge badge-pill {{subitem.badge.variant}}">
                                  {{ subitem.badge.text | translate }}</span>
                              }
                            </a>

                            <div class="collapse menu-dropdown sub-menu">
                              <ul class="nav nav-sm flex-column" aria-expanded="false">
                                @for (subSubitem of subitem.subItems; track $index) {
                                  <li class="nav-item">
                                    @if (hasItems(subSubitem)) {
                                      <a class="nav-link" href="javascript:void(0);"
                                         [attr.data-parent]="subSubitem.parentId"
                                         data-bs-toggle="collapse" aria-expanded="false"
                                         (click)="toggleExtraSubItem($event)">
                                        <i class="{{ subSubitem.icon }}"></i>
                                        {{ subSubitem.label | translate }}
                                        @if (subSubitem.badge) {
                                          <span class="badge badge-pill {{subSubitem.badge.variant}}">{{
                                              subSubitem.badge.text
                                                | translate
                                            }}</span>
                                        }
                                      </a>

                                      <div class="collapse menu-dropdown extra-sub-menu">
                                        @if (hasItems(subSubitem)) {
                                          <ul class="nav nav-sm flex-column" aria-expanded="false">
                                            @for (subSubitem1 of subSubitem.subItems; track $index) {
                                              <li class="nav-item">
                                                <a [attr.data-parent]="subSubitem1.parentId"
                                                   [routerLink]="subSubitem1.link"
                                                   class="nav-link" routerLinkActive="active"
                                                   [routerLinkActiveOptions]="{ exact: true }"
                                                   (click)="updateActive($event)">
                                                  <i class="{{ subSubitem.icon }}"></i>
                                                  {{ subSubitem1.label | translate }}
                                                </a>

                                              </li>
                                            }
                                          </ul>
                                        }
                                      </div>
                                    } @else {
                                      <a [routerLink]="subSubitem.link" class="nav-link" routerLinkActive="active"
                                         [routerLinkActiveOptions]="{ exact: true }"
                                         [attr.data-parent]="subSubitem.parentId"
                                         (click)="updateActive($event)">
                                        <i class="{{ subSubitem.icon }}"></i>
                                        {{ subSubitem.label | translate }}
                                      </a>
                                    }

                                  </li>
                                }
                              </ul>
                            </div>
                          } @else {
                            <a style="padding-left: 1rem !important;" [routerLink]="subitem.link" class="nav-link" routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }" [attr.data-parent]="subitem.parentId"
                               (click)="updateActive($event)">
                              <i class="{{ subitem.icon }}"></i>
                              {{ subitem.label | translate }}
                            </a>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                } @else {
                  <a [routerLink]="item.link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                     class="side-nav-link-ref nav-link menu-link" (click)="toggleParentItem($event)">
                    @if (item.icon) {
                      <i class="{{ item.icon }}" class=""></i>
                    }
                    <span class=""> {{ item.label | translate }}</span>
                    @if (item.badge) {
                      <span class="badge badge-pill {{item.badge.variant}}">{{
                          item.badge.text
                            | translate
                        }}</span>
                    }
                  </a>
                }

              </li>
            }
          </ng-container>
        }
      </ul>
    </div>
  </ngx-simplebar>

</div>
<div (click)="sidebarHide()" class="vertical-overlay"></div>
